/**
 * ShareService — Partage d'une image (try-on / flat-lay).
 *
 * v1.12.743 — Ouvre désormais le ShareSheet custom (Apps/Email/Download)
 * qui donne à l'utilisateur le choix au lieu du natif obscur.
 */

import { Platform, Share } from 'react-native';
import { getCurrentLang } from '../i18n';
import { showShareSheet } from '../components/ShareSheet';

function getShareText() {
  const lang = (() => { try { return getCurrentLang() || 'fr'; } catch { return 'fr'; } })();
  if (lang === 'en') {
    return {
      title: 'My MyTenue look',
      message: 'Check out my outfit composed by MyTenue — Your AI stylist ✨\nhttps://www.mytenue.com',
    };
  }
  return {
    title: 'Ma tenue MyTenue',
    message: 'Découvrez ma tenue composée par MyTenue — Votre styliste IA ✨\nhttps://www.mytenue.com',
  };
}

/**
 * Partage une image en ouvrant le ShareSheet custom (3 options Apps/Email/Download).
 * @returns {Promise<{ shared: boolean, method: string }>}
 */
export async function shareImage(imageUrl) {
  if (!imageUrl) throw new Error('imageUrl requis');
  const { title, message } = getShareText();
  // Ouvre le ShareSheet — l'utilisateur choisit ensuite (Apps natif / Email / Download)
  showShareSheet({ imageUrl, title, message });
  return { shared: true, method: 'share-sheet' };
}
